
<template>
  <div>
    <header-page showCiudadSelector @update="getInformesDiagnostico()" />
    <div class="container">
      <Breadcrumbs />
      <q-card>
        <div class="col-12 titleCard">Diagnóstico</div>
          <div class="divSubirInforme row">
            <div class="col-12">
            <q-btn
              unelevated
              :icon="'img:' + require('@/assets/img/upload-icon-white.svg')"
              class="bPrincipal"
              label="SUBIR INFORME"
              @click="triggerAdd()"
              :style="isOnlyAccess || isCiudadano ? 'display: none': ''"
            />
          </div>
          </div>
        <div class="row">
          <div class="col-12">
          <ListadoInformeDiagnostico :informesDiagnostico="informesDiagnostico" :isLoading ="isLoading" @getInformesDiagnostico="getInformesDiagnostico"/>
          <PopUpAñadirInformesDiagnostico v-model="showPopUpInformeDiagnostico"/>
        </div>
      </div>
      </q-card>
    </div>
  </div>
</template>
<script>
import HeaderPage from '@/components/shared/HeaderPage.vue';
import Breadcrumbs from '@/shared/breadcrumbs/Breadcrumbs.vue';
import ListadoInformeDiagnostico from '../components/ListadoInformeDiagnóstico.vue';
import PopUpAñadirInformesDiagnostico from '../components/PopUpAñadirInformesDiagnostico.vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import { mapGetters } from 'vuex';
import moment from 'moment';
export default {
  components: {
    HeaderPage,
    Breadcrumbs,
    ListadoInformeDiagnostico,
    PopUpAñadirInformesDiagnostico
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      isOnlyAccess: 'NGUD/isOnlyAccess',
      isCiudadano: 'NGUD/isCiudadano'
    })
  },
  mixins: [Loading],
  data () {
    return {
      showPopUpInformeDiagnostico: false,
      informesDiagnostico: [],
      isLoading: false
    };
  },
  created () {
    this.getInformesDiagnostico();
  },
  methods: {
    triggerAdd () {
      this.showPopUpInformeDiagnostico = true;
    },
    async getInformesDiagnostico () {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_GET_INFORMES_DIAGNOSTICO, { idCiudad: this.ciudadSelected.id }).then((response) => {
        this.hideLoading();
        this.isLoading = false;
        let informes = response.data;
        informes.forEach(informe => {
          let fecha = moment(new Date(informe.fechaSubida)).format('DD/MM/YYYY');
          informe.fechaSubida = fecha;
        });
        this.informesDiagnostico = informes;
      }).catch(() => {
        this.hideLoading();
      });
    }
  }
};
</script>
<style lang="scss" scoped>
  .divSubirInforme{
    padding: 15px;
  }
  .bPrincipal{
    display: flex;
    float:right;
  }
</style>
